import type { FC } from "react";

import { swSettings } from "app/common/services/swSettings";
import { EngagementOverviewKpi } from "app/pages/website-performance/components/EngagementOverviewKpi/EngagementOverviewKpi";
import { getHooksVersion } from "app/UtilitiesAndConstants/UtilityFunctions/hooksUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const EngagementOverviewKpiContainerDS: FC = () => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("digitalsuite_website_trafficandengagement", params),
            target: "_self",
        };
    };
    return (
        <EngagementOverviewKpi
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WsWebTrafficAndEngagement",
                hookModal: "trafficAndEngagement",
                version: getHooksVersion(swSettings),
                overrideTrackingKey: "TrendsOverTime",
            }}
        />
    );
};
